import outcomeEntrypointSelectorMap from './getOutcomeEntrypointSelector.json';
import deriveBaseComponentNameFromComponentName from './deriveBaseComponentNameFromComponentName.js';

function getOutcomeEntrypointSelector(componentName, product) {
  const baseComponentName =
    deriveBaseComponentNameFromComponentName(componentName);

  if (!baseComponentName) {
    if (__DEV__ || __PROD__) {
      console.error(
        `Web.Zephr:getOutcomeEntrypointSelector: "${componentName}" has an unknown base component name`,
      );
    }

    return null;
  }

  const outcomeEntrypointSelector =
    outcomeEntrypointSelectorMap[baseComponentName];

  return outcomeEntrypointSelector;
}

export default getOutcomeEntrypointSelector;
